import { render } from "./ProductCategoriesV2.vue?vue&type=template&id=5e858f9c&scoped=true"
import script from "./ProductCategoriesV2.vue?vue&type=script&lang=ts"
export * from "./ProductCategoriesV2.vue?vue&type=script&lang=ts"

import "./ProductCategoriesV2.vue?vue&type=style&index=0&id=5e858f9c&scoped=true&lang=css"
import "./ProductCategoriesV2.vue?vue&type=style&index=1&id=5e858f9c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5e858f9c"

export default script